var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCitsLogoNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 307,
    height: 78.554,
    viewBox: "0 0 307 78.554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fotter_Logo",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2849",
    "data-name": "Path 2849",
    d: "M20.294,87.366A19.892,19.892,0,0,1,0,67.072,19.9,19.9,0,0,1,20.294,46.777,19.962,19.962,0,0,1,30.52,49.46a17.914,17.914,0,0,1,6.994,7.229l-8.533,5a8.717,8.717,0,0,0-3.5-3.775,10.179,10.179,0,0,0-5.264-1.375A9.92,9.92,0,0,0,12.841,59.5a10.345,10.345,0,0,0-2.92,7.571,10.234,10.234,0,0,0,2.92,7.5,9.916,9.916,0,0,0,7.376,2.957,10.538,10.538,0,0,0,5.344-1.341,8.459,8.459,0,0,0,3.5-3.728l8.61,4.905a19.245,19.245,0,0,1-7.158,7.276A19.7,19.7,0,0,1,20.294,87.366Z",
    transform: "translate(0 -31.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2850",
    "data-name": "Path 2850",
    d: "M154.895,81.475A20.311,20.311,0,0,1,120.15,67.058a20.41,20.41,0,0,1,34.745-14.417,19.536,19.536,0,0,1,5.921,14.417A19.536,19.536,0,0,1,154.895,81.475Zm-21.87-6.806a9.993,9.993,0,0,0,7.42,3,10.132,10.132,0,0,0,7.457-3,10.312,10.312,0,0,0,3-7.611,10.312,10.312,0,0,0-3-7.611,10.132,10.132,0,0,0-7.457-3,9.993,9.993,0,0,0-7.42,3,10.4,10.4,0,0,0-2.96,7.611A10.373,10.373,0,0,0,133.025,74.668Z",
    transform: "translate(-79.866 -31.082)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2851",
    "data-name": "Path 2851",
    d: "M631.462,12.223a5.834,5.834,0,0,1-4.265-1.807,5.834,5.834,0,0,1-1.807-4.268,5.968,5.968,0,0,1,1.807-4.3A5.77,5.77,0,0,1,631.462,0a5.857,5.857,0,0,1,4.359,1.844,5.968,5.968,0,0,1,1.807,4.3,5.834,5.834,0,0,1-1.807,4.268,5.924,5.924,0,0,1-4.359,1.807Z",
    transform: "translate(-415.711 0.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2852",
    "data-name": "Path 2852",
    d: "M702.218,50.21h10.913l-14.6,38.436h-11.3L672.62,50.21h10.917l9.327,26.9Z",
    transform: "translate(-447.106 -33.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2853",
    "data-name": "Path 2853",
    d: "M807.487,71.368Q809.5,78.6,818.326,78.6q5.7,0,8.61-3.846l7.993,4.613q-5.7,8.228-16.764,8.228-9.535,0-15.3-5.767A19.718,19.718,0,0,1,797.1,67.294,19.859,19.859,0,0,1,802.8,52.8,19.565,19.565,0,0,1,817.4,47a18.324,18.324,0,0,1,13.954,5.844,20.29,20.29,0,0,1,5.5,14.45,23.284,23.284,0,0,1-.382,4.074Zm-.154-7.685h19.6a9.32,9.32,0,0,0-3.5-5.844,10.025,10.025,0,0,0-6.035-1.921,10.444,10.444,0,0,0-6.612,2.035A9.708,9.708,0,0,0,807.333,63.683Z",
    transform: "translate(-529.851 -31.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2854",
    "data-name": "Path 2854",
    d: "M471.53,41.93c.08.027.161.047.241.077h0a11.928,11.928,0,0,1,1.5.523,21.709,21.709,0,0,1,11.46,12.429c-.057-2.977-.131-5.961-.121-8.744h0V42.067",
    transform: "translate(-313.437 -27.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2855",
    "data-name": "Path 2855",
    d: "M431.02,75.186V68.892L431,64.4a22.641,22.641,0,0,0-.751-5.328v-.037a.676.676,0,0,0-.044-.171c-.07-.258-.144-.51-.221-.758A21.692,21.692,0,0,0,418.3,45.031a12.151,12.151,0,0,0-1.5-.523h0a19.972,19.972,0,0,0-22.155,6.887,21.293,21.293,0,0,0-3.909,16.854l3.5-3.018a.313.313,0,0,1,.406.476l-3.765,3.232c.124.557.265,1.11.432,1.653l3.417-2.934a.315.315,0,0,1,.409.476l-3.618,3.1c.188.557.4,1.11.63,1.65l3.1-2.659a.313.313,0,1,1,.409.473l-3.249,2.806a20.452,20.452,0,0,0,12.12,10.9,16.41,16.41,0,0,0,14.551-1.693,1.655,1.655,0,0,0,.982-1.572c-.044-1.532-.06-3.064-.074-4.6a3.2,3.2,0,0,1-1.318.285,3.259,3.259,0,0,1-2.9-1.78,10.506,10.506,0,0,1-7.909.838,11.265,11.265,0,0,1-8.452-8.744,11.259,11.259,0,0,1,3.45-11.547,10.661,10.661,0,0,1,11.959-2.216,10.836,10.836,0,0,1,7.135,9.8c.208,2.682.151,5.364.137,8.047V86.025l8.925-5.18Z",
    transform: "translate(-259.475 -28.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6238",
    "data-name": "Ellipse 6238",
    cx: 1.992,
    cy: 1.992,
    r: 1.992,
    transform: "translate(157.205 42.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2856",
    "data-name": "Path 2856",
    d: "M292.384,51.008a13.917,13.917,0,0,0-10.414-4.228q-7.839,0-11.456,5.364V47.86H260.6V87.473l9.914-5.727V65.539q0-4.768,2.307-7.151A8.163,8.163,0,0,1,278.97,56a7.557,7.557,0,0,1,5.535,2.038,7.877,7.877,0,0,1,2.075,5.881v22.37H296.5v-23.6Q296.5,55.236,292.384,51.008Z",
    transform: "translate(-173.227 -31.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2857",
    "data-name": "Path 2857",
    d: "M637.044,84.066V50.21H627.13V89.793Z",
    transform: "translate(-416.868 -33.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2858",
    "data-name": "Path 2858",
    d: "M556.12,34.762V25.23h-8.687V12.63l-9.914,5.727V25.23H530.83v9.532h6.689V50.751q0,7.923,4.188,10.994t14.417,1.921v-9a42.547,42.547,0,0,1-4.764.037,4.6,4.6,0,0,1-2.924-1.036,3.8,3.8,0,0,1-1.006-2.924V34.762Z",
    transform: "translate(-352.855 -8.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2859",
    "data-name": "Path 2859",
    d: "M109.518,212.64v7.125H108.1V212.64Z",
    transform: "translate(-71.857 -141.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2860",
    "data-name": "Path 2860",
    d: "M125.06,212.64v7.125h-1.341l-3.608-4.758v4.758H118.69V212.64h1.341l3.621,4.761V212.64Z",
    transform: "translate(-78.896 -141.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2861",
    "data-name": "Path 2861",
    d: "M150.37,212.64v7.125h-1.341l-3.594-4.758v4.758H144V212.64h1.341l3.621,4.761V212.64Z",
    transform: "translate(-95.72 -141.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2862",
    "data-name": "Path 2862",
    d: "M172.1,212.249a3.916,3.916,0,0,1,1.938.476,3.46,3.46,0,0,1,1.341,1.321,4.023,4.023,0,0,1,0,3.792,3.417,3.417,0,0,1-1.341,1.321,3.916,3.916,0,0,1-1.938.479,3.983,3.983,0,0,1-1.505-.282,3.393,3.393,0,0,1-1.958-1.941,4.04,4.04,0,0,1,0-2.947,3.494,3.494,0,0,1,.768-1.173,3.554,3.554,0,0,1,1.19-.768A3.979,3.979,0,0,1,172.1,212.249Zm0,1.361a2.176,2.176,0,0,0-1.623.65,2.538,2.538,0,0,0,0,3.353,2.347,2.347,0,0,0,3.249,0,2.548,2.548,0,0,0,0-3.353A2.173,2.173,0,0,0,172.1,213.61Z",
    transform: "translate(-111.913 -141.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2863",
    "data-name": "Path 2863",
    d: "M200.211,212.64l-2.682,7.125H195.8l-2.682-7.125h1.512l2.042,5.7,2.052-5.7Z",
    transform: "translate(-128.371 -141.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2864",
    "data-name": "Path 2864",
    d: "M219,212.64l2.776,7.125H220.26l-.62-1.66H216.6l-.62,1.66H214.5l2.773-7.125Zm-.878,1.4-1.036,2.739h2.062Z",
    transform: "translate(-142.583 -141.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2865",
    "data-name": "Path 2865",
    d: "M242.487,212.613v1.341h-2.209v5.8h-1.422v-5.81H236.65V212.6Z",
    transform: "translate(-157.307 -141.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2866",
    "data-name": "Path 2866",
    d: "M259.9,212.64v7.125H258.48V212.64Z",
    transform: "translate(-171.818 -141.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2867",
    "data-name": "Path 2867",
    d: "M271.782,212.249a3.9,3.9,0,0,1,1.935.476,3.436,3.436,0,0,1,1.341,1.321,4.023,4.023,0,0,1,0,3.792,3.393,3.393,0,0,1-1.341,1.321,3.9,3.9,0,0,1-1.935.479,4,4,0,0,1-1.509-.282,3.521,3.521,0,0,1-1.187-.768,3.446,3.446,0,0,1-.768-1.173,4.04,4.04,0,0,1,0-2.947,3.446,3.446,0,0,1,.768-1.173,3.571,3.571,0,0,1,1.187-.768A4,4,0,0,1,271.782,212.249Zm0,1.361a2.183,2.183,0,0,0-1.626.65,2.548,2.548,0,0,0,0,3.353,2.347,2.347,0,0,0,3.252,0,2.548,2.548,0,0,0,0-3.353A2.176,2.176,0,0,0,271.782,213.61Z",
    transform: "translate(-178.172 -141.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2868",
    "data-name": "Path 2868",
    d: "M302.07,212.64v7.125h-1.341l-3.587-4.758v4.758H295.7V212.64h1.341l3.618,4.761V212.64Z",
    transform: "translate(-196.559 -141.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2869",
    "data-name": "Path 2869",
    d: "M388.5,217.147H387v2.605H385.58v-7.125h2.907a2.786,2.786,0,0,1,1.931.607,2.347,2.347,0,0,1,0,3.306A2.769,2.769,0,0,1,388.5,217.147Zm-.034-3.212H387v1.914h1.462q1.17,0,1.173-.956T388.463,213.935Z",
    transform: "translate(-256.304 -141.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2870",
    "data-name": "Path 2870",
    d: "M407.726,212.64l2.773,7.125h-1.515l-.62-1.66h-3.041l-.62,1.66H403.22L406,212.64Zm-.892,1.4-1.006,2.739h2.062Z",
    transform: "translate(-268.029 -141.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2871",
    "data-name": "Path 2871",
    d: "M433.817,213.051l-.671,1.16a3.832,3.832,0,0,0-2.012-.607,1.878,1.878,0,0,0-.989.231.7.7,0,0,0-.376.624.526.526,0,0,0,.1.335.778.778,0,0,0,.319.231,2.971,2.971,0,0,0,.453.148c.154.04.352.077.6.117l.4.067q2.27.372,2.27,1.995a2.142,2.142,0,0,1-.241,1.023,1.968,1.968,0,0,1-.644.731,3.138,3.138,0,0,1-.929.422,4.06,4.06,0,0,1-1.1.144,5.7,5.7,0,0,1-1.643-.241,3.97,3.97,0,0,1-1.355-.694l.738-1.147a3.782,3.782,0,0,0,2.273.768,1.988,1.988,0,0,0,1.006-.228.7.7,0,0,0,.4-.63.563.563,0,0,0-.355-.53,4.2,4.2,0,0,0-1.157-.305l-.453-.074q-2.173-.335-2.173-2.038a2.1,2.1,0,0,1,.228-.979,1.968,1.968,0,0,1,.6-.7,3.017,3.017,0,0,1,.905-.422,3.793,3.793,0,0,1,1.083-.148,5.233,5.233,0,0,1,1.4.181A5.458,5.458,0,0,1,433.817,213.051Z",
    transform: "translate(-284.501 -141.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2872",
    "data-name": "Path 2872",
    d: "M455.46,213.051l-.671,1.16a3.812,3.812,0,0,0-2.012-.607,1.864,1.864,0,0,0-.986.231.7.7,0,0,0-.379.624.55.55,0,0,0,.1.335.778.778,0,0,0,.319.231,3.1,3.1,0,0,0,.453.148c.154.04.352.077.6.117l.4.067q2.27.372,2.27,1.995a2.179,2.179,0,0,1-.238,1.023,2.011,2.011,0,0,1-.647.731,3.156,3.156,0,0,1-.925.422,4.067,4.067,0,0,1-1.106.144,5.676,5.676,0,0,1-1.64-.241,3.91,3.91,0,0,1-1.361-.687l.738-1.147a3.762,3.762,0,0,0,2.27.768,2.011,2.011,0,0,0,1.006-.228.7.7,0,0,0,.392-.63.563.563,0,0,0-.355-.53,4.2,4.2,0,0,0-1.157-.305l-.453-.074q-2.173-.335-2.173-2.038a2.1,2.1,0,0,1,.228-.979,1.968,1.968,0,0,1,.63-.711,3.037,3.037,0,0,1,.905-.422,3.793,3.793,0,0,1,1.083-.148,5.217,5.217,0,0,1,1.4.181A5.364,5.364,0,0,1,455.46,213.051Z",
    transform: "translate(-298.886 -141.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2873",
    "data-name": "Path 2873",
    d: "M474.1,212.64v7.125H472.68V212.64Z",
    transform: "translate(-314.201 -141.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2874",
    "data-name": "Path 2874",
    d: "M485.982,212.249a3.9,3.9,0,0,1,1.935.476,3.436,3.436,0,0,1,1.341,1.321,4.023,4.023,0,0,1,0,3.792,3.393,3.393,0,0,1-1.341,1.321,3.9,3.9,0,0,1-1.935.479,4,4,0,0,1-1.509-.282,3.487,3.487,0,0,1-1.187-.768,3.446,3.446,0,0,1-.768-1.173,4.04,4.04,0,0,1,0-2.947,3.447,3.447,0,0,1,.768-1.173,3.537,3.537,0,0,1,1.187-.768A4,4,0,0,1,485.982,212.249Zm0,1.361a2.183,2.183,0,0,0-1.626.65,2.548,2.548,0,0,0,0,3.353,2.347,2.347,0,0,0,3.252,0,2.548,2.548,0,0,0,0-3.353A2.176,2.176,0,0,0,485.982,213.61Z",
    transform: "translate(-320.556 -141.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2875",
    "data-name": "Path 2875",
    d: "M516.27,212.64v7.125h-1.341l-3.6-4.758v4.758H509.9V212.64h1.341l3.618,4.761V212.64Z",
    transform: "translate(-338.942 -141.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2876",
    "data-name": "Path 2876",
    d: "M604.18,212.632h2.937a3.688,3.688,0,0,1,2.682.979,3.805,3.805,0,0,1,.02,5.177,3.688,3.688,0,0,1-2.682.976H604.2Zm2.92,1.341h-1.5v4.469h1.5a2.153,2.153,0,0,0,1.676-.614,2.6,2.6,0,0,0,0-3.245,2.163,2.163,0,0,0-1.676-.624Z",
    transform: "translate(-401.612 -141.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2877",
    "data-name": "Path 2877",
    d: "M634.624,218.46v1.3H629.3V212.64h5.284v1.3h-3.862v1.576h3.688v1.3h-3.688v1.636Z",
    transform: "translate(-418.31 -141.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2878",
    "data-name": "Path 2878",
    d: "M651,212.632h2.937a3.688,3.688,0,0,1,2.682.979,3.805,3.805,0,0,1,0,5.17,3.688,3.688,0,0,1-2.682.976H651Zm2.92,1.341h-1.5v4.469h1.5a2.152,2.152,0,0,0,1.676-.614,2.6,2.6,0,0,0,0-3.245,2.163,2.163,0,0,0-1.663-.624Z",
    transform: "translate(-432.734 -141.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2879",
    "data-name": "Path 2879",
    d: "M677.582,212.64v7.125H676.16V212.64Z",
    transform: "translate(-449.459 -141.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2880",
    "data-name": "Path 2880",
    d: "M689.455,212.249a3.856,3.856,0,0,1,1.8.422,3.017,3.017,0,0,1,1.254,1.17l-1.22.748a2.142,2.142,0,0,0-.778-.724,2.209,2.209,0,0,0-1.066-.258,2.159,2.159,0,0,0-1.613.654,2.531,2.531,0,0,0,0,3.37,2.286,2.286,0,0,0,3.46-.335l1.16.835a3.353,3.353,0,0,1-1.264,1.106,3.782,3.782,0,0,1-1.743.4,4.046,4.046,0,0,1-1.505-.278,3.447,3.447,0,0,1-1.187-.764,3.39,3.39,0,0,1-.771-1.173,4.124,4.124,0,0,1,0-2.961,3.421,3.421,0,0,1,.771-1.173,3.547,3.547,0,0,1,1.187-.764,4.047,4.047,0,0,1,1.512-.272Z",
    transform: "translate(-455.807 -141.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2881",
    "data-name": "Path 2881",
    d: "M713.376,212.64l2.773,7.125h-1.516l-.62-1.66h-3.041l-.62,1.66H708.87l2.776-7.125Zm-.882,1.4-1.033,2.739h2.062Z",
    transform: "translate(-471.202 -141.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2882",
    "data-name": "Path 2882",
    d: "M736.847,212.613v1.341h-2.21v5.8h-1.422v-5.81H731V212.6Z",
    transform: "translate(-485.912 -141.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2883",
    "data-name": "Path 2883",
    d: "M754.272,212.64v7.125H752.85V212.64Z",
    transform: "translate(-500.437 -141.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2884",
    "data-name": "Path 2884",
    d: "M766.158,212.249a3.906,3.906,0,0,1,1.938.476,3.437,3.437,0,0,1,1.341,1.321,4.023,4.023,0,0,1,0,3.792,3.393,3.393,0,0,1-1.341,1.321,3.909,3.909,0,0,1-1.938.479,3.993,3.993,0,0,1-1.505-.282,3.456,3.456,0,0,1-1.187-.768,3.5,3.5,0,0,1-.771-1.173,4.087,4.087,0,0,1,0-2.947,3.417,3.417,0,0,1,1.958-1.941A3.993,3.993,0,0,1,766.158,212.249Zm0,1.361a2.179,2.179,0,0,0-1.623.65,2.538,2.538,0,0,0,0,3.353,2.347,2.347,0,0,0,3.249,0,2.548,2.548,0,0,0,0-3.353A2.173,2.173,0,0,0,766.158,213.61Z",
    transform: "translate(-506.798 -141.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2885",
    "data-name": "Path 2885",
    d: "M796.464,212.64v7.125h-1.341l-3.6-4.758v4.758H790.1V212.64h1.341l3.618,4.761V212.64Z",
    transform: "translate(-525.197 -141.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2049",
    "data-name": "Rectangle 2049",
    width: 3.034,
    height: 3.034,
    transform: "translate(116.68 72.98) rotate(45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2050",
    "data-name": "Rectangle 2050",
    width: 3.034,
    height: 3.034,
    transform: "translate(189.42 72.981) rotate(45)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitsLogoNew);
export default __webpack_public_path__ + "static/media/cits_logo_new.9dcedc61bc5091f58e55d4a9571d0581.svg";
export { ForwardRef as ReactComponent };